import { Link, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { api } from 'API';
import { getSupplierRedirectCode } from 'API/Treatment/treatment';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { HTTP_STATUS_CODES } from 'Enum/HttpStatusCodes';
import { useDictionary } from 'Hooks';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { addImposterToUrl, downloadFile } from 'Utils';

export const TestLinks = () => {
  const testMenuDictionary = useDictionary(Dictionary, DICTIONARY.TestMenu);

  const navigate = useNavigate();

  const exportToPdf = async (formName: string) => {
    const response = await api.get(
      addImposterToUrl(`MedicationsPdf/${formName}`, true)
    );

    if (response.status === HTTP_STATUS_CODES.OK) {
      downloadFile(response.data, '.pdf', formName);
    } else if (response.status === HTTP_STATUS_CODES.NoContent) {
      alert(testMenuDictionary.errorCreatingFile);
    } else if (response.request.status === HTTP_STATUS_CODES.Forbidden) {
      alert(testMenuDictionary.errorForbidden);
    } else {
      alert(testMenuDictionary.generalError);
    }
  };

  const newDisabilityConfirmationPdfExport = async (
    id: number,
    formName: string
  ) => {
    const fileSource = await api.get<any>(
      addImposterToUrl(`/DisabilityConfirmations/${id}`, true)
    );
    if (fileSource.data) downloadFile(fileSource.data, '.pdf', formName);
    else if (fileSource.status === HTTP_STATUS_CODES.NoContent)
      alert(
        `${testMenuDictionary.errorCreatingFile} או למשתמש אין גישה לזכות זו`
      );
    else if (fileSource.status === HTTP_STATUS_CODES.Forbidden)
      alert(testMenuDictionary.errorForbidden);
    else alert(testMenuDictionary.generalError);
  };

  const discountPurchaseTaxID = 3,
    FreeExemptionID = 2,
    PropertyTaxReductionID = 1,
    ConsentFeeID = 7;

  return (
    <>
      <Helmet>
        <title>{testMenuDictionary.title}</title>
      </Helmet>
      <Link
        href={process.env.REACT_APP_REDIRECT_URL + 'equipment'}
        underline={'hover'}
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.equipment}
        </Typography>
      </Link>
      <br />
      <Link
        href={process.env.REACT_APP_REDIRECT_URL + 'recognitionStatus'}
        underline={'hover'}
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.recognitionStatus}
        </Typography>
      </Link>
      <br />
      <Link
        href={process.env.REACT_APP_REDIRECT_URL + 'notifications'}
        underline={'hover'}
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.notifications}
        </Typography>
      </Link>
      <br />
      <Link
        href={process.env.REACT_APP_REDIRECT_URL + 'applies'}
        underline={'hover'}
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.applies}
        </Typography>
      </Link>
      <br />
      <Link
        onClick={() => exportToPdf('DisabilityConfirmation')}
        underline={'hover'}
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.DisabilityConfirmation}
        </Typography>
      </Link>
      <br />
      <Link
        onClick={() => exportToPdf('DisabilityConfirmationWithDetails')}
        underline={'hover'}
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.DisabilityConfirmationWithDetails}
        </Typography>
      </Link>
      <br />
      <Link
        onClick={() => exportToPdf('DisabilityConfirmationForAbroad')}
        underline={'hover'}
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.DisabilityConfirmationForAbroad}
        </Typography>
      </Link>
      <br />
      <Link
        onClick={() =>
          newDisabilityConfirmationPdfExport(
            discountPurchaseTaxID,
            testMenuDictionary.DisabilityConfirmationDiscountPurchaseTax
          )
        }
        underline='hover'
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.DisabilityConfirmationDiscountPurchaseTax}
        </Typography>
      </Link>

      <br />
      <Link
        onClick={() =>
          newDisabilityConfirmationPdfExport(
            FreeExemptionID,
            testMenuDictionary.DisabilityConfirmationFreeExemption
          )
        }
        underline='hover'
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.DisabilityConfirmationFreeExemption}
        </Typography>
      </Link>

      <br />
      <Link
        onClick={() =>
          newDisabilityConfirmationPdfExport(
            PropertyTaxReductionID,
            testMenuDictionary.DisabilityConfirmationPropertyTaxReduction
          )
        }
        underline='hover'
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.DisabilityConfirmationPropertyTaxReduction}
        </Typography>
      </Link>
      <br />
      <Link
        onClick={() =>
          newDisabilityConfirmationPdfExport(
            ConsentFeeID,
            testMenuDictionary.DisabilityConfirmationConsentFee
          )
        }
        underline='hover'
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.DisabilityConfirmationConsentFee}
        </Typography>
      </Link>

      <br />
      <br />
      <u>
        <b>{testMenuDictionary.directLinks}</b>
      </u>
      <br />
      <Link
        onClick={() => navigate('/Confirmations/DisabilityConfirmation')}
        underline={'hover'}
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.DisabilityConfirmation}
        </Typography>
      </Link>
      <br />
      <Link
        onClick={() =>
          navigate('/Confirmations/DisabilityConfirmationWithDetails')
        }
        underline={'hover'}
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.DisabilityConfirmationWithDetails}
        </Typography>
      </Link>
      <br />
      <Link
        onClick={() =>
          navigate('/Confirmations/DisabilityConfirmationForAbroad')
        }
        underline={'hover'}
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.DisabilityConfirmationForAbroad}
        </Typography>
      </Link>
      <br />
      <Link
        onClick={() =>
          navigate(
            `/Confirmations/${discountPurchaseTaxID}?file=DisabilityConfirmationDiscountPurchaseTax`
          )
        }
        underline='hover'
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.DisabilityConfirmationDiscountPurchaseTax}
        </Typography>
      </Link>
      <br />
      <Link
        onClick={() =>
          navigate(
            `/Confirmations/${FreeExemptionID}?file=DisabilityConfirmationFreeExemption`
          )
        }
        underline='hover'
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.DisabilityConfirmationFreeExemption}
        </Typography>
      </Link>
      <br />
      <Link
        onClick={() =>
          navigate(
            `/Confirmations/${PropertyTaxReductionID}?file=DisabilityConfirmationPropertyTaxReduction`
          )
        }
        underline='hover'
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.DisabilityConfirmationPropertyTaxReduction}
        </Typography>
      </Link>
      <br />
      <Link
        onClick={() =>
          navigate(
            `/Confirmations/${ConsentFeeID}?file=DisabilityConfirmationConsentFee`
          )
        }
        underline='hover'
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.DisabilityConfirmationConsentFee}
        </Typography>
      </Link>
      <br />
      <br />
      <u>
        <b>{testMenuDictionary.requestsForms}</b>
      </u>
      <br />
      <Link
        href={
          process.env.REACT_APP_REDIRECT_URL +
          'requests/update-personal-details/8/18'
        }
        underline={'hover'}
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.updatePersonalDetails}
        </Typography>
      </Link>
      <br />
      <Link
        href={
          process.env.REACT_APP_REDIRECT_URL +
          'requests/update-bank-details/8/19'
        }
        underline={'hover'}
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.updateBankAccount}
        </Typography>
      </Link>
      <br />
      <Link
        href={process.env.REACT_APP_REDIRECT_URL + 'requests/general/5/24'}
        underline={'hover'}
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.tofes106}
        </Typography>
      </Link>
      <br />
      <Link
        href={process.env.REACT_APP_REDIRECT_URL + 'requests/expense-claim/3/5'}
      >
        {testMenuDictionary.expenseClaim}
      </Link>
      <br />
      <br />
      <Link
        href={process.env.REACT_APP_REDIRECT_URL + 'personal-details'}
        underline={'hover'}
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.viewPersonalDetails}
        </Typography>
      </Link>
      <br />
      <Link
        href={process.env.REACT_APP_REDIRECT_URL + 'personal-team'}
        underline={'hover'}
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.personalTeam}
        </Typography>
      </Link>
      <br />
      <Link
        href={process.env.REACT_APP_REDIRECT_URL + 'compass-rights'}
        underline={'hover'}
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.compassRights}
        </Typography>
      </Link>
      <br />
      <Link
        href={process.env.REACT_APP_REDIRECT_URL + 'medical-referrals'}
        underline={'hover'}
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.medicalReferrals}
        </Typography>
      </Link>
      <br />
      <Link
        href={process.env.REACT_APP_REDIRECT_URL + 'paychecks'}
        underline={'hover'}
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.paychecks}
        </Typography>
      </Link>
      <br />
      <Link
        href={process.env.REACT_APP_REDIRECT_URL + 'treatment'}
        underline={'hover'}
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.treatment}
        </Typography>
      </Link>
      <br />
      <Link
        href={process.env.REACT_APP_REDIRECT_URL + 'payments&deductions'}
        underline={'hover'}
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.confirmBenefits}
        </Typography>
      </Link>
      <br />
      <Link
        href={process.env.REACT_APP_REDIRECT_URL + 'documents'}
        underline={'hover'}
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.documents}
        </Typography>
      </Link>
      <br />
      <Link
        href={process.env.REACT_APP_REDIRECT_URL + 'otp-login'}
        underline={'hover'}
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.otpLogin}
        </Typography>
      </Link>
      <br />
      <Link
        href={process.env.REACT_APP_REDIRECT_URL + 'universalRequest'}
        underline={'hover'}
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.universalRequest}
        </Typography>
      </Link>
      <br />
      <Link href={process.env.REACT_APP_REDIRECT_URL + 'otp-login'}>
        {testMenuDictionary.otpLogin}
      </Link>
      <br />
      <Link href={process.env.REACT_APP_REDIRECT_URL + 'universalRequest'}>
        {testMenuDictionary.universalRequest}
      </Link>
      <br />
      <Link
        href={process.env.REACT_APP_REDIRECT_URL + 'disability-confirmations'}
        underline={'hover'}
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.disabilityConfirmations}
        </Typography>
      </Link>
      <br />
      <Link
        href={process.env.REACT_APP_REDIRECT_URL + 'B2C'}
        underline={'hover'}
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.B2C}
        </Typography>
      </Link>
      <br />
      <Link
        href={`https://privateareadesign2023.z6.web.core.windows.net${window.location.hash}`}
        underline={'hover'}
      >
        <Typography variant={'body3'} tabIndex={0}>
          {testMenuDictionary.B2CMatrixLogin}
        </Typography>
      </Link>
      <br />
      <br />
      <u>
        <b>{testMenuDictionary.redirectsCodes}</b>
      </u>
      <br />
      <Link
        onClick={async () => {
          const code = await getSupplierRedirectCode(2);
          if (code)
            window.open(
              `https://shikum.eshet.com/?code=${encodeURIComponent(code)}`
            );
          else alert(testMenuDictionary.redirectError);
        }}
        underline={'hover'}
      >
        <Typography variant={'body3'}>
          {testMenuDictionary.eshetTurs}
        </Typography>
      </Link>
      <br />
      <Link
        onClick={async () => {
          const code = await getSupplierRedirectCode(1);
          if (code)
            window.open(
              `https://flying-shikum.co.il/?code=${encodeURIComponent(code)}`
            );
          else alert(testMenuDictionary.redirectError);
        }}
        underline={'hover'}
      >
        <Typography variant={'body3'}>
          {testMenuDictionary.flyingCarpet}
        </Typography>
      </Link>
      <Box mb='25px'></Box>
    </>
  );
};
